import { ViewModule } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useState } from "react";
import ListWithFilter from "../../common/components/ListWithFilter";
import { useToastService } from "../../common/hooks";

interface AppSelectorDialogProps {
  open: boolean;
  onClose: () => void;
  onAppChanged: (appName: string) => void;
  availableApps: string[];
  currentAppName?: string;
}

const AppSelectorDialog: React.FC<AppSelectorDialogProps> = ({ open, onClose, onAppChanged, availableApps, currentAppName }) => {
  const [selectedAppName, setSelectedAppName] = useState<string | undefined>();
  const toast = useToastService();

  const handleAppSelect = (app: { id: string; name: string }) => {
    setSelectedAppName(app.id);
  };

  const handleConfirm = () => {
    if (!selectedAppName) {
      toast.info("Please select an app");
      return;
    }

    onAppChanged(selectedAppName);
    toast.success("App changed successfully");
    onClose();
  };

  const handleClose = () => {
    setSelectedAppName(undefined);
    onClose();
  };

  const appItems = availableApps.map((appName) => ({
    id: appName,
    name: appName,
    description: appName === currentAppName ? "(Current)" : undefined,
  }));

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select App</DialogTitle>
      <DialogContent>
        <ListWithFilter
          items={appItems}
          selectedItemId={selectedAppName}
          onSelected={handleAppSelect}
          placeholder="Search apps..."
          displayNameProperty="name"
          keyProperty="id"
          maxHeight="400px"
          emptyMessage="No apps available"
          icon={() => <ViewModule />}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" disabled={!selectedAppName}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppSelectorDialog;
